export default "__VITE_ASSET__CpuzV0d7__"